/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum RegistryType {
  Tm = 'TM',
}

export function instanceOfRegistryType(value: any): boolean {
  for (const key in RegistryType) {
    if (Object.prototype.hasOwnProperty.call(RegistryType, key)) {
      if (RegistryType[key as keyof typeof RegistryType] === value) {
        return true
      }
    }
  }
  return false
}

export function RegistryTypeFromJSON(json: any): RegistryType {
  return RegistryTypeFromJSONTyped(json, false)
}

export function RegistryTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryType {
  return json as RegistryType
}

export function RegistryTypeToJSON(value?: RegistryType | null): any {
  return value as any
}
